import { render, staticRenderFns } from "./SingleAnswerMatrix.vue?vue&type=template&id=74d9eae7&scoped=true&"
import script from "./SingleAnswerMatrix.vue?vue&type=script&lang=js&"
export * from "./SingleAnswerMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SingleAnswerMatrix.vue?vue&type=style&index=0&id=74d9eae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d9eae7",
  null
  
)

export default component.exports